window.app.controller('SALoginCtrl', ['$scope', '$mdDialog', '$http', function ($scope, $mdDialog, $http) {

    $scope.showRegistrationSection = false;
    $scope.firstStepShow = true;
    $scope.successStepShow = false;
    $scope.checkInProgress = false;
    $scope.changePassInProcess = false;
    $scope.showAuthReg = true;
    $scope.userMailAgentLink = '';
    $scope.userExists = false;
    $scope.fromChangePasswordEmail = false;
    $scope.emailChecks = {};
    $scope.withoutSave;
    $scope.sendAtOnce;

    $scope.logRegInfo = {
        rememberMe: false
    };

    class loginInfo {
        constructor(acceptAdPolicy, acceptMailingPolicy, acceptTerms, email, password) {
            this.accept_personal_data_terms = +acceptAdPolicy;
            this.accept_mailing_policy = +acceptMailingPolicy;
            this.accept_terms = +acceptTerms;
            this.email = email;
            this.password = password;
            // this.repeatPassword = repeatPassword;
            // this.rememberMe = rememberMe;
            // this.applicationData = applicationData;
        }
    }

    $scope.showMessage = () => {
        if (document.referrer.split('change-password').length > 1) {
            return 'Hasło zmienione'
        }
    };

    $scope.loginAdviceMess = `<div id="modal-popup">
                                    <p class="title text-center">Zaloguj się na konto, żeby kontynuować wysyłanie wniosku</p>
                                    <div class="layout layout-xs-column" layout-align="space-between" layout-align-xs="center center">
                                        <button class="action-btn sa-exist-off" ng-click="toAuthForm()" aria-label="yes">Autoryzacja</button>
                                        <button class="action-btn sa-exist-off" ng-click="setSendAtOnce()" aria-label="no">Kontynuować wypełnianie wniosku</button>
                                    </div>
                                </div>`

    $scope.showLoginAdviceMess = () => {
        $mdDialog.show({
            clickOutsideToClose: true,
            preserveScope: true,
            template: $scope.loginAdviceMess,
            parent: angular.element(document.body),
            scope: $scope,
        });
        $scope.$watch('$viewContentLoaded', function () {
            let mdDialog = $("#modal-popup").parent();
            mdDialog.css({ "max-width": "570px" });
        })
    }

    $scope.setSendAtOnce = () => {
        $scope.sendAtOnce = true;
        $scope.closeDialog();
    }

    $scope.toAuthForm = () => {
        $scope.closeDialog();
        $scope.withoutSave = true;
        document.getElementById('sa-auth-form').style.cssText = 'display: block !important'
        $scope.scrollTo("#sa-auth-form");
    }

    $scope.resendRegConfirmLetter = async (evt) => {
        // evt.preventDefault();

        try {
            const res = await $scope.sendMessage();
        } catch (err) {
            console.error(err);
        }

    };

    $scope.mailRedirect = function () {
        window.location.href = $scope.userMailAgentLink;
    };

    $scope.sendMessage = () => {
        return $http({
            method: 'POST',
            url: '/api/front/registration/registration/resend-letter',
            data: {
                type: 'user',
                fromApplication: true,
                email: $scope.user.email,
            }
        });
    };

    $scope.debug = () => {
        console.log($scope.authForm);
    };

    $scope.saveCheckResultInCache = data => {
        $scope.emailChecks[$scope.user.email] = data;
    };

    $scope.emailAlreadyChecked = () => {
        return typeof $scope.emailChecks[$scope.user.email] !== 'undefined';
    };

    $scope.collectFormData = () => {
        return $scope.needRegistration ? $scope.cpaClientData() : $scope.user;
    };

    $scope.cpaClientData = () => {
        return angular.extend($scope.user, { repeatPassword: $scope.user.repeatPassword })
    };

    $scope.submitAuth = () => {
        $scope.formErrorText = '';
        $scope.formErrorLink = '';
        let authData = new loginInfo($scope.user.acceptAdPolicy, $scope.user.acceptMailingPolicy, $scope.user.acceptTerms,
            $scope.user.email, $scope.logRegInfo.password);
        authData.type = 'user';
        authData.fromApplication = true;
        if ($scope.showRegistrationSection) {
            $scope.sendXHR({
                url: '/api/front/registration/registration/register/',
                data: authData,
                successFunc: $scope.registSuccess
            })
        } else {
            $scope.sendXHR({
                url: '/api/front/authorization/authorization/authorize',
                data: authData,
                successFunc: $scope.loginSuccess
            })
        }
    }

    $scope.registSuccess = (response) => {
        if (response.data.registrationSuccess) {
            $scope.saveApplication();
            $scope.successStepShow = true;
            $scope.showAuthReg = false;
            $scope.showRegistrationSection = false;
        }
        $scope.formErrorText = response.data.message;
        $scope.formErrorLink = response.data.link;
    }

    $scope.loginSuccess = (response) => {
        if (response.data.authSuccess) {
            $scope.sendAtOnce ? localStorage.setItem("sendAtOnce", true) : "";
            !$scope.withoutSave ? $scope.saveApplication() : "";
            $scope.redirect(response.data.authUrl);
        }
        $scope.formErrorText = response.data.message;
        $scope.formErrorLink = response.data.link;
    }

    $scope.manageAuthForm = () => {
        $scope.showRegistrationSection ? document.querySelector(".sa-auth").style['max-width'] = "700px" : document.querySelector(".sa-auth").style['max-width'] = "500px"
    }

    $scope.getRangesVal = (fromChangePasswordEmail) => {
        $scope.fromChangePasswordEmail = fromChangePasswordEmail;
        if (fromChangePasswordEmail) {
            $scope.user = JSON.parse(localStorage.getItem("SAData"));
            localStorage.removeItem("SAData");
            $scope.$emit("passUserData", {
                user: $scope.user
            })
        }
        $scope.user.costVal = +(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500);
        $scope.user.durationVal = +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30);
        $scope.costVal = +(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500);
        $scope.durationVal = +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30);
    }

    $scope.toogleChangePassForm = () => {
        $scope.changePassInProcess ? $scope.changePassInProcess = false : $scope.changePassInProcess = true;
        $scope.showAuthReg ? $scope.showAuthReg = false : $scope.showAuthReg = true;
    }

    $scope.ableLogin = () => {
        $scope.showAuthReg = true;
        $scope.successStepShow = false;
        $scope.changePassInProcess = false;
    }

    $scope.$watch('logRegInfo.password', function () {
        !$scope.logRegInfo.password ? $scope.formErrorText = "" : "";
    })

}])



// WEBPACK FOOTER //
// src/js/controllers/singleApplication/SALoginCtrl.js